import React from "react";
import VendorsMain from "../components/Vendors/VendorsMain";

function Vendors() {
  return (
    <div>
      <VendorsMain />
    </div>
  );
}

export default Vendors;
